import { render, staticRenderFns } from "./MainSportFilter.vue?vue&type=template&id=1033792f&scoped=true&"
import script from "./MainSportFilter.vue?vue&type=script&lang=js&"
export * from "./MainSportFilter.vue?vue&type=script&lang=js&"
import style0 from "./MainSportFilter.vue?vue&type=style&index=0&id=1033792f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1033792f",
  null
  
)

export default component.exports